import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UrlModifyService {
  modifyUrl(url: string, height?: number, width?: number): string {
    if (url === '') {
      return url;
    }

    if (width !== undefined) {
      url = url.concat('&width=', String(width));
    }

    if (height !== undefined) {
      url = url.concat('&height=', String(height));
    }

    return url;
  }
}
